import React from 'react';

// Sidebar Skeleton Component
export const SidebarSkeleton: React.FC = () => {
  return (
    <div className="fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-lg border-r border-gray-200">
      {/* Logo Section */}
      <div className="flex items-center justify-center h-16 px-4 border-b border-gray-200">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-gray-300 rounded-lg animate-pulse"></div>
          <div className="w-32 h-6 bg-gray-300 rounded animate-pulse"></div>
        </div>
      </div>

      {/* User Profile Section */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gray-300 rounded-full animate-pulse"></div>
          <div className="flex-1">
            <div className="w-24 h-4 bg-gray-300 rounded animate-pulse mb-1"></div>
            <div className="w-20 h-3 bg-gray-300 rounded animate-pulse"></div>
          </div>
          <div className="w-6 h-6 bg-gray-300 rounded animate-pulse"></div>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="flex-1 px-4 py-4 space-y-2 overflow-y-auto">
        {/* Dashboard */}
        <div className="flex items-center space-x-3 px-3 py-2 rounded-lg bg-gray-100">
          <div className="w-5 h-5 bg-gray-300 rounded animate-pulse"></div>
          <div className="w-20 h-4 bg-gray-300 rounded animate-pulse"></div>
        </div>

        {/* Patient Management */}
        <div className="space-y-1">
          <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
            <div className="w-5 h-5 bg-gray-300 rounded animate-pulse"></div>
            <div className="w-24 h-4 bg-gray-300 rounded animate-pulse"></div>
            <div className="w-4 h-4 bg-gray-300 rounded animate-pulse ml-auto"></div>
          </div>
          <div className="ml-8 space-y-1">
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-16 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-20 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-18 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Doctor Management */}
        <div className="space-y-1">
          <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
            <div className="w-5 h-5 bg-gray-300 rounded animate-pulse"></div>
            <div className="w-20 h-4 bg-gray-300 rounded animate-pulse"></div>
            <div className="w-4 h-4 bg-gray-300 rounded animate-pulse ml-auto"></div>
          </div>
          <div className="ml-8 space-y-1">
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-16 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-20 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Appointments */}
        <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
          <div className="w-5 h-5 bg-gray-300 rounded animate-pulse"></div>
          <div className="w-24 h-4 bg-gray-300 rounded animate-pulse"></div>
        </div>

        {/* Treatments */}
        <div className="space-y-1">
          <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
            <div className="w-5 h-5 bg-gray-300 rounded animate-pulse"></div>
            <div className="w-20 h-4 bg-gray-300 rounded animate-pulse"></div>
            <div className="w-4 h-4 bg-gray-300 rounded animate-pulse ml-auto"></div>
          </div>
          <div className="ml-8 space-y-1">
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-18 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-16 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Billing */}
        <div className="space-y-1">
          <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
            <div className="w-5 h-5 bg-gray-300 rounded animate-pulse"></div>
            <div className="w-16 h-4 bg-gray-300 rounded animate-pulse"></div>
            <div className="w-4 h-4 bg-gray-300 rounded animate-pulse ml-auto"></div>
          </div>
          <div className="ml-8 space-y-1">
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-20 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-18 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-16 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Pharmacy */}
        <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
          <div className="w-5 h-5 bg-gray-300 rounded animate-pulse"></div>
          <div className="w-20 h-4 bg-gray-300 rounded animate-pulse"></div>
        </div>

        {/* Laboratory */}
        <div className="space-y-1">
          <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
            <div className="w-5 h-5 bg-gray-300 rounded animate-pulse"></div>
            <div className="w-24 h-4 bg-gray-300 rounded animate-pulse"></div>
            <div className="w-4 h-4 bg-gray-300 rounded animate-pulse ml-auto"></div>
          </div>
          <div className="ml-8 space-y-1">
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-16 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-20 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Inventory */}
        <div className="space-y-1">
          <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
            <div className="w-5 h-5 bg-gray-300 rounded animate-pulse"></div>
            <div className="w-20 h-4 bg-gray-300 rounded animate-pulse"></div>
            <div className="w-4 h-4 bg-gray-300 rounded animate-pulse ml-auto"></div>
          </div>
          <div className="ml-8 space-y-1">
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-18 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-16 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Reports */}
        <div className="space-y-1">
          <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
            <div className="w-5 h-5 bg-gray-300 rounded animate-pulse"></div>
            <div className="w-16 h-4 bg-gray-300 rounded animate-pulse"></div>
            <div className="w-4 h-4 bg-gray-300 rounded animate-pulse ml-auto"></div>
          </div>
          <div className="ml-8 space-y-1">
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-20 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-18 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-16 h-3 bg-gray-300 rounded animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Admin Section */}
        <div className="pt-4 border-t border-gray-200">
          <div className="space-y-1">
            <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
              <div className="w-5 h-5 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-12 h-4 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse ml-auto"></div>
            </div>
            <div className="ml-8 space-y-1">
              <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
                <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
                <div className="w-16 h-3 bg-gray-300 rounded animate-pulse"></div>
              </div>
              <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
                <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
                <div className="w-20 h-3 bg-gray-300 rounded animate-pulse"></div>
              </div>
              <div className="flex items-center space-x-3 px-3 py-2 rounded-lg">
                <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
                <div className="w-18 h-3 bg-gray-300 rounded animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Bottom Section */}
      <div className="p-4 border-t border-gray-200">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-gray-300 rounded-lg animate-pulse"></div>
          <div className="flex-1">
            <div className="w-20 h-3 bg-gray-300 rounded animate-pulse mb-1"></div>
            <div className="w-16 h-3 bg-gray-300 rounded animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Top Navigation Skeleton
export const TopNavSkeleton: React.FC = () => {
  return (
    <div className="fixed top-0 right-0 left-64 z-40 bg-white shadow-sm border-b border-gray-200">
      <div className="flex items-center justify-between h-16 px-6">
        {/* Breadcrumb */}
        <div className="flex items-center space-x-2">
          <div className="w-16 h-4 bg-gray-300 rounded animate-pulse"></div>
          <div className="w-2 h-2 bg-gray-300 rounded-full animate-pulse"></div>
          <div className="w-20 h-4 bg-gray-300 rounded animate-pulse"></div>
        </div>

        {/* Right Side Actions */}
        <div className="flex items-center space-x-4">
          {/* Search */}
          <div className="w-64 h-10 bg-gray-300 rounded-lg animate-pulse"></div>
          
          {/* Notifications */}
          <div className="relative">
            <div className="w-10 h-10 bg-gray-300 rounded-full animate-pulse"></div>
            <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-300 rounded-full animate-pulse"></div>
          </div>
          
          {/* Profile */}
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-gray-300 rounded-full animate-pulse"></div>
            <div className="w-20 h-4 bg-gray-300 rounded animate-pulse"></div>
            <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Complete Layout Skeleton with Sidebar
export const LayoutSkeleton: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <SidebarSkeleton />
      
      {/* Top Navigation */}
      <TopNavSkeleton />
      
      {/* Main Content */}
      <div className="ml-64 pt-16">
        {children}
      </div>
    </div>
  );
};
